/* Storefront extras: recently viewed + cart savings calculator refresh */
(function () {
  var RECENT_KEY = 'ug-recently-viewed';
  var RECENT_MAX = 8;
  var RECENT_SHOW = 6;

  function money(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function normalizeRecentEntry(entry) {
    if (!entry) return null;
    if (typeof entry === 'string') {
      return { h: entry, t: entry, p: '', img: '' };
    }
    if (entry.h) return entry;
    return null;
  }

  function readRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.map(normalizeRecentEntry).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) { /* private browsing */ }
  }

  function resolveProductImage() {
    try {
      if (window.product_json) {
        var pj = window.product_json;
        if (pj.featured_image) return pj.featured_image;
        if (pj.images && pj.images.length) {
          var first = pj.images[0];
          if (typeof first === 'string') return first;
          if (first && first.src) return first.src;
        }
      }
    } catch (e) { /* ignore */ }

    var meta = document.querySelector('meta[itemprop="image"]');
    if (meta) {
      var content = meta.getAttribute('content');
      if (content) return content;
    }

    var imgEl = document.querySelector(
      '.product-content[data-product-handle] .photos img, .photos-wrapper img, .ug-splice-media-shell img'
    );
    if (imgEl) {
      return imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src') || '';
    }
    return '';
  }

  function persistEnrichedImages(enriched) {
    if (!enriched.length) return;
    var byHandle = {};
    enriched.forEach(function (item) {
      if (item.h && item.img) byHandle[item.h] = item.img;
    });
    if (!Object.keys(byHandle).length) return;
    var list = readRecent().map(function (item) {
      if (byHandle[item.h]) return Object.assign({}, item, { img: byHandle[item.h] });
      return item;
    });
    writeRecent(list);
  }

  function enrichRecentImages(items, done) {
    var missing = items.filter(function (item) { return item.h && !item.img; });
    if (!missing.length) {
      done(items);
      return;
    }
    var remaining = missing.length;
    missing.forEach(function (item) {
      fetch('/products/' + encodeURIComponent(item.h) + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (product && product.featured_image) item.img = product.featured_image;
        })
        .catch(function () {})
        .finally(function () {
          remaining -= 1;
          if (remaining === 0) {
            persistEnrichedImages(items);
            done(items);
          }
        });
    });
  }

  function renderRecentCards(nodes, items) {
    nodes.forEach(function (el) {
      if (!items.length) {
        el.hidden = true;
        el.innerHTML = '';
        return;
      }
      el.hidden = false;
      var html = '<p class="ug-recent__label">Recently viewed</p><div class="ug-recent__row">';
      items.forEach(function (item) {
        var title = String(item.t || item.h).replace(/"/g, '');
        var img = item.img
          ? '<img class="ug-recent__img" src="' + item.img + '" alt="" loading="lazy" />'
          : '<span class="ug-recent__img ug-recent__img--empty"></span>';
        html +=
          '<a class="ug-recent__card" href="/products/' + item.h + '" title="' + title + '">' +
            img +
            '<span class="ug-recent__meta">' +
              '<span class="ug-recent__title">' + title + '</span>' +
              (item.p ? '<span class="ug-recent__price">' + item.p + '</span>' : '') +
            '</span>' +
          '</a>';
      });
      html += '</div>';
      el.innerHTML = html;
    });
  }

  function trackProductView() {
    var article = document.querySelector('[data-product-handle]');
    if (!article) return;
    var handle = article.getAttribute('data-product-handle');
    if (!handle) return;

    var titleEl = document.querySelector('.page-title, [itemprop="name"]');
    var priceEl = document.querySelector('.actual-price, [itemprop="price"]');

    var entry = {
      h: handle,
      t: titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : handle,
      p: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
      img: resolveProductImage()
    };

    var list = readRecent().filter(function (item) { return item.h !== handle; });
    list.unshift(entry);
    writeRecent(list);
  }

  function renderRecent() {
    var nodes = document.querySelectorAll('[data-ug-recently-viewed]');
    if (!nodes.length) return;

    var current = document.querySelector('[data-product-handle]');
    var currentHandle = current ? current.getAttribute('data-product-handle') : '';
    var items = readRecent().filter(function (item) {
      return item.h && item.h !== currentHandle;
    }).slice(0, RECENT_SHOW);

    if (!items.length) {
      renderRecentCards(nodes, items);
      return;
    }

    if (items.some(function (item) { return !item.img; })) {
      enrichRecentImages(items.slice(), function (enriched) {
        renderRecentCards(nodes, enriched);
      });
      renderRecentCards(nodes, items);
      return;
    }

    renderRecentCards(nodes, items);
  }

  /* —— Cart savings calculator (live refresh) —— */
  function isSamplePack(item) {
    var pt = (item.product_type || '').toLowerCase();
    return pt.indexOf('sample pack') !== -1;
  }

  function isBundleItem(item) {
    var pt = (item.product_type || '').toLowerCase();
    return pt.indexOf('bundle') !== -1
      || (item.handle || '').toLowerCase().indexOf('bundle') !== -1
      || (item.product_title || item.title || '').toLowerCase().indexOf('bundle') !== -1;
  }

  function refreshSavingsCalc(cart) {
    var el = document.querySelector('[data-ug-savings-calc]');
    if (!el || !cart) return;

    var hasBundle = false;
    var packQty = 0;
    var minUnit = null;
    var targetInCart = false;
    var bundleHandle = el.getAttribute('data-bundle-handle') || 'the-bundle-3';

    cart.items.forEach(function (item) {
      if (isBundleItem(item)) hasBundle = true;
      if (item.handle === bundleHandle) targetInCart = true;
      if (isSamplePack(item)) {
        packQty += item.quantity;
        if (minUnit === null || item.price < minUnit) minUnit = item.price;
      }
    });

    if (hasBundle || packQty === 0) {
      el.closest('.row').style.display = 'none';
      return;
    }
    el.closest('.row').style.display = '';

    var rem = packQty % 3;
    var free = Math.floor(packQty / 3);
    var toNext = rem === 0 ? 0 : 3 - rem;
    var b2g1Est = (minUnit && free > 0) ? minUnit * free : 0;
    var applied = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));

    var b2g1Li = el.querySelector('.ug-savings-calc__row--b2g1');
    if (b2g1Li) {
      if (free > 0 && b2g1Est > 0) {
        b2g1Li.innerHTML =
          '<span class="ug-savings-calc__name">Buy 2, get 1 free</span>' +
          '<span class="ug-savings-calc__val" data-savings-b2g1-applied>~' + money(b2g1Est) + ' at checkout</span>';
      } else if (toNext > 0) {
        b2g1Li.innerHTML =
          '<span class="ug-savings-calc__name">Buy 2, get 1 free</span>' +
          '<span class="ug-savings-calc__val" data-savings-b2g1-next>' + toNext + ' pack' + (toNext !== 1 ? 's' : '') + ' to next free</span>';
      }
    }

    var appliedRow = el.querySelector('.ug-savings-calc__row--applied');
    if (applied > 0) {
      if (!appliedRow) {
        var list = el.querySelector('.ug-savings-calc__list');
        if (list) {
          appliedRow = document.createElement('li');
          appliedRow.className = 'ug-savings-calc__row ug-savings-calc__row--applied';
          list.appendChild(appliedRow);
        }
      }
      if (appliedRow) {
        appliedRow.innerHTML =
          '<span class="ug-savings-calc__name">Applied now</span>' +
          '<span class="ug-savings-calc__val ug-savings-calc__val--accent">' + money(applied) + ' off</span>';
        appliedRow.hidden = false;
      }
    } else if (appliedRow) {
      appliedRow.hidden = true;
    }

    var bundleSave = parseInt(el.getAttribute('data-bundle-save'), 10) || 0;
    var bundleMore = parseInt(el.getAttribute('data-bundle-more'), 10) || 0;
    if (cart.total_price != null && el.getAttribute('data-bundle-price')) {
      bundleMore = parseInt(el.getAttribute('data-bundle-price'), 10) - cart.total_price;
    }
    var bundleVal = el.querySelector('[data-savings-bundle]');
    if (bundleVal && bundleSave > 0 && !targetInCart) {
      bundleVal.textContent = bundleMore > 0
        ? money(bundleSave) + ' off · +' + money(bundleMore)
        : money(bundleSave) + ' off';
    }
  }

  function onCartUpdated(_e, cart) {
    if (cart) refreshSavingsCalc(cart);
  }

  function fillRatingTemplate(template, count) {
    if (!template) return String(count);
    return template.replace(/__COUNT__|\{\{\s*count\s*\}\}/g, String(count));
  }

  function applyPdpBuyRating() {
    var link = document.querySelector('[data-ug-pdp-buy-rating]');
    if (!link) return;

    var productId = link.getAttribute('data-product-id');
    var countEl = link.querySelector('[data-ug-pdp-rating-count]');
    var avgEl = link.querySelector('[data-ug-pdp-rating-avg]');
    var starsEl = link.querySelector('[data-ug-pdp-rating-stars]');
    var labelTpl = link.getAttribute('data-rating-label');
    var ariaTpl = link.getAttribute('data-rating-aria');

    var count = 0;
    if (countEl && countEl.textContent) {
      var m = countEl.textContent.match(/\d+/);
      if (m) count = parseInt(m[0], 10);
    }

    var widget = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget
      ? window.jdgm.data.reviewWidget[productId]
      : null;

    if (widget) {
      var wCount = widget.reviews_count || widget.review_count || widget.number_of_reviews || widget.total_reviews || 0;
      if (wCount > count) count = wCount;
      var avg = widget.average_rating || widget.average_score || widget.rating || 0;
      if (avg > 0) {
        if (avgEl) {
          avgEl.textContent = (Math.round(avg * 10) / 10).toFixed(1);
          avgEl.hidden = false;
        }
        if (starsEl) {
          starsEl.style.setProperty('--ug-rating-fill', Math.min(100, Math.round((avg / 5) * 100)) + '%');
        }
      }
    }

    if (count > 0) {
      link.hidden = false;
      link.classList.remove('ug-pdp-buy-rating--pending');
      if (countEl) countEl.textContent = fillRatingTemplate(labelTpl, count);
      link.setAttribute('aria-label', fillRatingTemplate(ariaTpl, count));
    }
  }

  function pollPdpBuyRating(tries) {
    applyPdpBuyRating();
    var pending = document.querySelector('[data-ug-pdp-buy-rating][hidden]');
    if (pending && tries < 12) {
      setTimeout(function () { pollPdpBuyRating(tries + 1); }, 300);
    }
  }

  function onPageView() {
    trackProductView();
    renderRecent();
    pollPdpBuyRating(0);
  }

  function boot() {
    document.addEventListener('ug:cart-state-updated', onCartUpdated);
    document.addEventListener('ug:page-view', onPageView);
    var start = function () { onPageView(); };
    if (window.requestAnimationFrame) {
      requestAnimationFrame(start);
    } else {
      setTimeout(start, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
